<template>
  <div id = "countdown">
    <hr class = "line">
    <div class = "countTitle">Timpul se scurge</div>
    <div class = "timecase">
      <div class = "block_day">
        <p class = "digit"> {{days}} </p>
        <p class = "text"> {{$t('countdown.dz')}} </p>
      </div>
      <div class = "block_hour">
        <p class = "digit"> {{hours}} </p>
        <p class = "text">{{$t('countdown.hrs')}} </p>
      </div>
      <div class = "block_minute">
        <p class = "digit"> {{minutes}} </p>
        <p class = "text"> {{$t('countdown.min')}} </p>
      </div>
    </div>
    <hr class = "line">
  </div>
</template>



<script>
export default {
  props: [
    'ext_date'
  ],
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: Math.trunc(Date.parse(this.ext_date) / 1000)
    }
  },
  computed: {
    seconds () {
      return (this.date - this.now) % 60 > 0 ? (this.date - this.now) % 60 : 0;
    },
    minutes() {
      return Math.trunc((this.date - this.now) / 60) % 60 > 0 ? Math.trunc((this.date - this.now) / 60) % 60 : 0;
    },
    hours() {
      return Math.trunc((this.date - this.now) / 60 / 60) % 24 > 0 ?  Math.trunc((this.date - this.now) / 60 / 60) % 24 : 0;
    },
    days() {
      return Math.trunc((this.date - this.now) / 60 / 60 / 24) > 0 ?  Math.trunc((this.date - this.now) / 60 / 60 / 24) : 0;
    }
  },
  mounted() {
    window.setInterval( () => {
      this.now = Math.trunc( (new Date()).getTime() / 1000 );
    }, 1000);
  },

}
</script>





<style scoped lang="scss">

#countdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.line { 
  border: 1px solid #EDF6FB;
  margin-left: 37vw;
  margin-right: 37vw;
  z-index:100;
  opacity: 0.8;
  border-radius: 50%;
}

.timecase {
  display: flex;
  justify-content: center;
  margin-top: 0.5%;
  margin-bottom: -3%;
}

.block_day, .block_hour, .block_minute {
  display: flex;
  margin: 1.5vh;
  margin-top: -2vh;
  text-align: center;
}

.countTitle {
  margin-top: -1vh ;
  color: #EDF6FB;
  font-family: "Acumin Variable Concept";
  font-weight: 200;
  word-spacing: 0vw;
  font-size: 5.75vh;
  text-align: center;
}

.text {
  color: #EDF6FB;
  text-align: center;
  font-weight: 100;
  font-size: 5vh;
  font-family: "Acumin Variable Concept";
  font-weight: bold;
}

.digit {
  color: #EDF6FB;
  font-size: 5vh;
  font-family: "Acumin Variable Concept";
  font-weight: bold;

}

@media only screen and (max-width: 1024px) {
  .text {
    font-size: 1.75vh;
  }

  .digit {
    font-size: 1.75vh;
  }

  .countTitle {
    font-size: 2.25vh;
    word-spacing: 1vw;
    margin-top: -2vh;
  }

  .block_day, .block_hour, .block_minute {
    margin-bottom: -5vh;
    margin-top: -0.5vh;
    margin-right: 2vw;
    margin-left: 2vw;
  }

  .line {
    margin-left: 34vw;
    margin-right: 34vw;
    border-radius:0;
    border-top:0px;
  } 
  
  .timecase {
    margin-top: 0.05%;
    margin-bottom: -0.5vh;
  }

}


//4k (3840/2160)
@media only screen and (min-width: 3840px) {
#countdown {
  line-height: 9.5vh;
}
.countTitle {
  margin-bottom: -1.5vh;
}
}
</style>